<template>
	<view>
		
	</view>
</template>

<script>
	export default {
		name:"BioIntelligentPart1",
		data() {
			return {
				
			};
		}
	}
</script>

<style>

</style>